// extracted by mini-css-extract-plugin
export default {"links":"links-I7fuB","category":"category-KpdLL","title":"title-_Ko03","linkItem":"linkItem-_Cwwx","newTagWrapper":"newTagWrapper-EMfz6"};